import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [activeFields, setActiveFields] = useState({
    name: false,
    email: false,
    message: false,
  });
  const [statusMessage, setStatusMessage] = useState("");

  const handleFocus = (field) => {
    setActiveFields((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setActiveFields((prev) => ({ ...prev, [field]: false }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      user_name: formData.name,
      user_email: formData.email,
      message: formData.message,
    };

    emailjs
      .send(
        "service_x552j7o", // Reemplaza con tu Service ID
        "template_8o74894", // Reemplaza con tu Template ID
        templateParams
      )
      .then(
        (response) => {
          console.log("Correo enviado:", response.status, response.text);
          setStatusMessage("¡Mensaje enviado exitosamente!");
        },
        (error) => {
          console.error("Error al enviar el correo:", error);
          setStatusMessage(
            "Hubo un error al enviar el mensaje. Intenta nuevamente."
          );
        }
      );

    // Limpia el formulario
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="container-contact">
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="row">
          <div className="col">
            <input
              type="text"
              name="name"
              placeholder="Su nombre"
              className={`form-input ${activeFields.name ? "active" : ""}`}
              value={formData.name}
              required
              onFocus={() => handleFocus("name")}
              onBlur={(e) => {
                if (e.target.value === "") handleBlur("name");
              }}
              onChange={handleChange}
            />
          </div>
          <div className="col">
            <input
              type="email"
              name="email"
              placeholder="Su E-mail"
              className={`form-input ${activeFields.email ? "active" : ""}`}
              value={formData.email}
              required
              onFocus={() => handleFocus("email")}
              onBlur={(e) => {
                if (e.target.value === "") handleBlur("email");
              }}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <textarea
              name="message"
              placeholder="Su mensaje a FibraLink"
              className={`form-textarea ${
                activeFields.message ? "active" : ""
              }`}
              rows="6"
              value={formData.message}
              required
              onFocus={() => handleFocus("message")}
              onBlur={(e) => {
                if (e.target.value === "") handleBlur("message");
              }}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="button-container">
          <button type="submit" className="submit-button">
            Enviar
          </button>
        </div>
        {statusMessage && <p className="status-message">{statusMessage}</p>}
      </form>
    </div>
  );
};

export default ContactForm;
